// 由主机名解析机构 id (Tenant-ID), 服务端与客户端共用
// 规则:
//   1. 本地开发 (localhost / 192.x / 39.x) 固定为根域名机构 C, 需要其它机构时用 ?debugId=xxx
//   2. 无二级域名 (wenkoo.com.cn / www.wenkoo.com.cn) 为根域名机构 C, 展示可信 (kexin) 模板
//   3. 有二级域名 (jigou.wenkoo.com.cn) 取二级域名作为机构 id

export const ROOT_DOMAIN = 'wenkoo.com.cn'
/** 根域名 (无二级域名) 对应的机构 id */
export const ROOT_TENANT_ID = 'C'
export const LOCAL_TENANT_ID = 'C'

const LOCAL_HOST_PREFIXES = ['localhost', '192', '39']

function stripPort(hostname: string): string {
  return hostname.split(':')[0].toLowerCase()
}

export function isLocalHost(hostname: string): boolean {
  const host = stripPort(hostname)
  return LOCAL_HOST_PREFIXES.some((prefix) => host.startsWith(prefix))
}

/** 是否为无二级域名的根域名访问 */
export function isRootDomain(hostname: string): boolean {
  const host = stripPort(hostname)
  return host === ROOT_DOMAIN || host === `www.${ROOT_DOMAIN}`
}

export function isRootTenant(tenantId?: string | null): boolean {
  return tenantId === ROOT_TENANT_ID
}

/** 机构对应的接口域名: 根域名机构直接用 wenkoo.com.cn, 其余用二级域名 */
export function getTenantHost(tenantId: string): string {
  return isRootTenant(tenantId) ? ROOT_DOMAIN : `${tenantId}.${ROOT_DOMAIN}`
}

export function resolveTenantId(hostname?: string | null): string {
  if (!hostname) return ROOT_TENANT_ID
  if (isLocalHost(hostname)) return LOCAL_TENANT_ID
  if (isRootDomain(hostname)) return ROOT_TENANT_ID

  const host = stripPort(hostname)
  const suffix = `.${ROOT_DOMAIN}`
  const subdomain = host.endsWith(suffix) ? host.slice(0, -suffix.length) : host
  const tenantId = subdomain.split('.')[0]
  return tenantId && tenantId !== 'www' ? tenantId : ROOT_TENANT_ID
}

export type ApiService = 'portal' | 'tenant'

const SERVICE_PATH: Record<ApiService, string> = {
  portal: '/wk-api/wenkoo-portal',
  tenant: '/wk-api/wenkoo-tenant',
}

/** 机构默认使用的后端服务: 根域名机构 C 走 wenkoo-portal, 其余机构走 wenkoo-tenant */
export function getServiceForTenant(tenantId: string): ApiService {
  return isRootTenant(tenantId) ? 'portal' : 'tenant'
}

/** 服务的相对路径前缀, 如 /wk-api/wenkoo-portal */
export function getServicePath(service: ApiService): string {
  return SERVICE_PATH[service]
}
